'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/operator/filter');

var _ajax = require('../util/ajax');

var _util = require('../util');

var _form = require('../form');

var _modal = require('../ui/modal');

var _choices = require('choices.js');

var _choices2 = _interopRequireDefault(_choices);

var _jump = require('./jump');

var _jump2 = _interopRequireDefault(_jump);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postcodeLookup = void 0;
var contactDetailsContainer = void 0;
var contactFormContainer = void 0;
var accordionContainer = void 0;
var postcodeLookupAccordion = void 0;

function init() {
    postcodeLookup = document.querySelector('.js-contact-postcode-lookup');
    if (!postcodeLookup) {
        return;
    }
    contactDetailsContainer = document.querySelector('.js-contact-details');

    contactFormContainer = document.querySelector('.js-contact-form-box');

    accordionContainer = calcAccordionHeight(postcodeLookup);

    (0, _form.Controller)('.js-contact-postcode-lookup-form', postcodeLookupReturn);

    var click = _Observable.Observable.fromEvent(document, 'click');

    click.filter(function (evt) {
        return evt.target.classList.contains('js-contact-existing-customer');
    }).subscribe(existingCustomer);

    click.filter(function (evt) {
        return evt.target.classList.contains('js-contact-genral');
    }).subscribe(generalEnquiry);

    _jump2.default.init();
}

function generalEnquiry(evt) {
    var _evt$target$dataset = evt.target.dataset,
        action = _evt$target$dataset.action,
        token = _evt$target$dataset.token;

    (0, _ajax.post)(action, {
        options: 'contact-details',
        _token: token,
        generalEnquiry: 1
    }).then(function (data) {
        return JSON.parse(data);
    }).then(function (data) {
        addContactDetails(data.view);
        closeAccordion(postcodeLookup);
    }).catch(console.log);
}

function existingCustomer(evt) {
    if (!accountFound()) {
        openAccordion(postcodeLookup);
        closeAccordion(contactFormContainer);
    } else {
        var _evt$target$dataset2 = evt.target.dataset,
            action = _evt$target$dataset2.action,
            token = _evt$target$dataset2.token;

        (0, _ajax.post)(action, { options: 'contact-details', _token: token }).then(function (data) {
            return JSON.parse(data);
        }).then(function (data) {
            addContactDetails(data.view);
        }).catch(console.log);
    }
}

function postcodeLookupReturn(_ref) {
    var data = _ref.data,
        formData = _ref.formData;

    if (data.success) {
        if (data.view) {
            addContactDetails(data.view);
            closeAccordion(postcodeLookup);
        }

        this.resetForm();
        return;
    }

    if (data.msg) {
        this.errorMessageEl.innerHTML = '<p>' + data.msg + '</p>';
        this.errorMessageEl.classList.add('active');
    }

    if (data.modal) {
        setupModal(data.modal);
    }
}

function setupModal(html) {
    _modal.modalController.addModal('postcodeLookupModal', html);
    _modal.modalController.openModal('postcodeLookupModal');

    var modal = document.querySelector('[data-modal-item-id=postcodeLookupModal]');

    if (!modal) {
        return;
    }

    var form = modal.querySelector('form');
    (0, _form.Controller)(form, onModalSuccess);
}

function onModalSuccess(_ref2) {
    var data = _ref2.data,
        formData = _ref2.formData;

    if (data.success) {
        _modal.modalController.closeModal('postcodeLookupModal');

        if (data.view) {
            addContactDetails(data.view);
            postcodeLookup.classList.remove('active');
        }
        return;
    }

    if (data.msg) {
        this.errorMessageEl.innerHTML = '<p>' + data.msg + '</p>';
        this.errorMessageEl.classList.add('active');
    }
}

function addContactDetails(view) {
    contactDetailsContainer.innerHTML = view;
    openAccordion(contactFormContainer);
    (0, _form.Controller)('.js-form');
    (0, _form.inputGroup)();

    var selects = contactDetailsContainer.querySelectorAll('.js-select');
    Array.prototype.forEach.call(selects, function (el) {
        return new _choices2.default(el, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            callbackOnCreateTemplates: function callbackOnCreateTemplates(template) {
                var classNames = this.config.classNames;
                return {
                    containerInner: function containerInner() {
                        return template('\n                    <div class="' + classNames.containerInner + '">\n                        <div class="choices__btn">\n                            <svg><use xlink:href="/images/svgicons.svg#arrow-small-down"></use></svg>\n                        </div>\n                    </div>\n                ');
                    }
                };
            }
        });
    });
}

function accountFound() {
    return (0, _util.getCookie)('vivid');
}

function calcAccordionHeight(element, cb) {
    var cleanUp = false;

    if (!element.classList.contains('active')) {
        element.classList.add('active');
        cleanUp = true;
    }

    var container = element.firstElementChild;

    var _container$getBoundin = container.getBoundingClientRect(),
        height = _container$getBoundin.height;

    element.dataset.accordionHeight = height;

    if (cleanUp) {
        element.style.height = 0;
        element.classList.remove('active');
    } else {
        element.style.height = Math.ceil(height) + 'px';
    }

    if (cb) {
        requestAnimationFrame(cb);
    }
}

function openAccordion(element) {
    var postcodeHeight = 0;
    if (postcodeLookup.classList.contains('active')) {
        postcodeHeight = postcodeLookup.dataset.accordionHeight;
    }

    calcAccordionHeight(element, function () {
        var height = element.dataset.accordionHeight;
        element.style.height = Math.ceil(height) + 'px';
        element.classList.add('active');

        _jump2.default.jump(element, null, -postcodeHeight);
    });
}

function closeAccordion(element) {
    element.classList.remove('active');
    element.style.height = 0;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/contact-page.js
// module id = ./resources/assets/js/src/ui/contact-page.js
// module chunks = 0